import { AuthProvider } from 'react-admin';
import { useMsal } from '@azure/msal-react';
import { isAuthenticated } from '../src/authConfig';
import { useStore } from 'react-admin';
import { setActiveAccount } from '@azure/msal-browser/dist/cache/AccountManager';

/*const AuthenticationProvider = () => {

    const login = ({ username, password }) => {
        if (username !== 'john' || password !== '123') {
            return Promise.reject();
        }
        localStorage.setItem('username', username);
        return Promise.resolve();
    };

    const logout =  () => {
        localStorage.removeItem('username');
        // const { instance } = useMsal();
        //instance.logout();
        return Promise.resolve();
    };

    const checkError= () => {
        Promise.resolve()
    };

    const checkAuth = () => {
        sessionStorage.getItem('msal.account.keys') ? Promise.resolve() : Promise.reject()
    };
    const getPermissions = () => {
        Promise.resolve()
    };

}*/
// @ts-ignore
const authProvider = (token, instance) => {
  return {
    login: async () => {
      try {
        await instance.loginRedirect({
          scopes: ['user.read'],
        });
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    logout: () => {
      //localStorage.removeItem('username');
      // const { instance } = useMsal();
      // token ? instance.logout() : null;
      // return Promise.resolve();

      const accounts = instance.getAllAccounts();

      sessionStorage.clear();
      localStorage.clear();

      if (accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);
        return instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: window.location.origin,
          onRedirectNavigate: () => false,
        });
      }

      return Promise.resolve();
    },
    checkError: (error: any) => {
      if (error.name === 'AbortError' || error.message?.includes('aborted')) {
        return Promise.resolve({ message: false });
      }
      const status = error.status;

      if (status === 401) {
        return Promise.reject();
      }
      if (status === 403) {
        return Promise.resolve();
      }
      return Promise.resolve();
    },
    checkAuth: () => {
      const accounts = instance.getAllAccounts();
      if (accounts.length === 0) return Promise.reject();

      const expiration = accounts[0].idTokenClaims?.exp;
      const now = Math.floor(Date.now() / 1000);

      if (expiration && now > expiration) {
        return Promise.reject({ redirectTo: '/login' });
      }

      return Promise.resolve();
    },
    getPermissions: () => {
      try {
        return Promise.resolve({
          adminPermission: token.idTokenClaims.groups.includes('41868d92-f54c-4848-8c86-4905d0fae643') ? true : false,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    getIdentity: () => {
      try {
        return Promise.resolve({
          id: 'user',
          fullName: token.name,
          username: token.username,
          avatar:
            'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADMCAAAAADsJcGfAAASnElEQVR42u1de5gVxZU/1d33zn0OMwwwPByBWSDyEhNWHCOrbtCNihrUoKvmE3WJMbvBR167+bKa1U30c7+wiazGAIuPD1HWiJEoQQRUAoTnQFDeyENmeM3APO+d++ru2j9O9c3tO3dmbs9Ud9fcmfpnvpqurtPnd7vrVJ2q8zuEAgAAbdUAACDkAQCAtgQAABQFAAAgFQEAADlMAAD0Vh0AgIRlAACIpAAAIFAEAACJNgAA8IQAAEBrpQAAUlgqCBkgQX/Ju/SD1Q9WP1j9YPWmojBrSAj+xSpgDYyL+D9TU8KaElNTyGoKGU17vQwgzfjHh69YHC2vFy1vKom21gcAAHocjXQRGum4DgAAPrS8SbS8Hi/a2ji+tj400gm9IGSAgr0SCdtSVsWaijV2DTT88WQUopuashsVrLFrIOOPp+kFIaN/zLI0Zgn1NDTeFGmKtiX1gMcTDJUGdbkfrJwl1XTywGeff3EhmkhqOkiK1xcaNHTUhHEXFXv6wTKVRM2+TdUnmlK68Q8tFWs+dxQkpeTiy6qmj/QJBRbNtJvtvg6S4yLJtM3ZBW1u1sWOZOjnd67ediqeS7ierKurXlYx/daqwVKPZHDRg6BVhSR24ZEyzYeMUOpoTgmaU5rCpl7sgr0MzHxoKpoN/HIodk48pBMZ0tF3f38g2sVvGpo466ZR3m7L4KMHKKwaw26L2MQkldmW1WQFZzQxNNJ+7DbBJiaezOdhNU3FGY1f6lCGVrti+XGtyw8gsm3n4jvuGy93SwYvPVwes+jpt948pufVVDs2f+UD915E+uwAH1v7m78k826tH/7ZqsdvCPRNsGjNb5c3WbojuWn/fY+O7IteB23jw4ubrN7U8MJ9n6h9D6y2Jf+8VbN+m7rxvsUxt56ZMKPN1hU688wzR4fOVtnsXTA1ZTXWlN3ImrIbs5pmymj478WRbj5yaO6/luYlg7seCu5/dLDHgRc9fuw1hkba19k+Ct6Ywh9f9qORjrfbRzn37PJkd3/fyEttTw3NQwZ3PVwa4M8+vSLVg7XRq8lnhvUZa3j+P3uCFUDyDfLc4D4CVsuzb6d61kNymf8ZFyZcLljDxG/eSPW0j+TLv070BbC0lYs46BlfsEJ3/NFJW6ajwry3kV3No5ZH0933H+by5ONe/jLJ8+F46UGcPhhy/rHVlM/PPGvRICjsgyHqsvV8sAK6+hW1wMes3Uu4DczxF6sLG6zIwlP8Oqv5n0hBg7VxHeXXmb7q40IGq+WVFp7dNS1scfTxFcMXz/armfsfffpsN4OyWso06Tf2xJn739yU1diOHxuIFWnbFr5Pv+HjG7Nl2KmHEs3pdcD1eSLa1UTgr0Ya1+dFwc6MdHx5lC9YkSV/G+50IsBVD0c/Q7pnE+8ut+wr1DFL/cMF3l02fKAVKFh1a7kv5/SPzxcoWNVH+Pd5dE9hgqV+YsMcMrLZwTWPggaUaGypiFWKT0CxJmFNx/On7IwdZafhdLxIWD9GU3YjnsTAM3bN2yj/56fbG8oyZNiqByhoTmkUB8og2toYvgNevKgyAxpE1dHykiAa6SjaWj82TUYye9Wi2BQt7+Ev7Pi1jx66NEOGrXqAYjhuunbysOO9FDo53pt92Jed2CEAAPsb7QCr6eDkDBm26uHgmEU/TdrRbXIfdUwF58CKHbFFK3osUYBgtdXY029tWwGC1dJgT7+Nrc5NHTQTaObD9gRrFGsSzr+pcSoAMptSU1N2o469Ep0CwIWoTW9sq5yWYa8eoLCJYhDrMTSgvlDmopsZUB1rBC0vRFGKH410PJK5sGdGWjLmJRQA6mw6/JLQQ2kZ9uoBCjtgknVshEFp/AbMKqNrA5vSrKMpphuJ0Su6T6gOAG1Jm8CKS2kZ9urh4Jil2uQf0FKOqeAgWHbN39QCBMuuMBwiFyBYik1Kyc6F9iiGre16mEuHfpqadjaUpsNLJQAIeOwZ4b1+PS3DXj0McwoxFs/py1x0Gx5+80SgDe/0s5jReObC3vDwm410gADAEL89E60iEknLsFcP4+PIK54TZ3G6nn/MKM4UJUkCgIFBezzAgbCWlmGvHg6OWSWl9vRbWlyAA3ygwp5+R/gLECz/GFuClEilrwDBIpfaYuM9E5wLFMsiwejcuWq2vPk4cDMt74SSOjuGwvHENEuxUQ/D60CQEQKS8RyLbsOAoq0lGG5AkXUCvL4cC3vDSKM9pxjSMOhiO8Aa/aVQhgxb9QCF7QCxeM44Vr24BaSZtoeMmFHZFDPqw4tJbCqbtqCMmFHcdApPq+bvWCaXD1IyZNiqh5ObrJ5rbTjnH7jKwbAHJ7fvLx/Dv8/KL0NhglU+g7vhItcMLlCwPLcO5D59v1EpULDIV67k3eW0yeCkAmyLUjXt5qNpMdaR1GRMwDiSSTJvRNNirFWJyZiAcexTf/chvrsWgVe/kS3DTj0Udu7UzM7FNheK8KLB1eU3kUeY2bkC2DSBTQ2urpiJoCKuXTVtA1ewrrre206GfXo4fLS7ZE6IZ3fh75Q4+vgOBw187VqOBpF8/TooZLCKHyrn19nweQMKGiyYNsfLqyvvd6qgsMHy3j+d04dIvvZtr8MP73gkK93+wHE+7ob/rXI8khUPAjlIJq4u+jceh4SKn/um3KEMe/RwIaBcmT2Hg8vU+/A9zjNNukBV4H/sjh4v6JR7fuyHvgAWDHxiZg/RUu74RRn0DbBg2NM39Qgt5bbnhkNfAQsqfj6rB+OW56757tCzucWfVffs0u46IPz3PlEOrvBnEbeyo7QseL57Zx+GfG9OmP+ERuzsKMXzFkzphnBp6pLHwm49s3sEiZ5/WHSPZYdN+MFlN3lde2QXqTelsb+4cuF+KydClUsfuT3s3gO7S+oavuuK198+le/OK6m498FKV8n+3aULlip/Mnv57/OCiwy75Z8uc5kZ3n3Wbtj3u/e6jOzyjbl51pd8brN2G16HkAIAQKM5DSgGbqgRk5GOqAAAJJjTSGNwiBIyGemOZGin/7x6V13Hx3O95VfcevUIpUcyeOiR/gw7p5DPdbFzmvpcFzuSIVfceUvt7s1/qY2q2d0ROThiUtW14wKkhzK46CFGWgYSmDjt/vrjn+49VtPclkhRACAeX3DA0IvHTxxVVhQSJIuFMAk/iK+i4motcq6pMRqNq74iXyhcWkK9QqW6ESuVjByig3MsXkQp/UmKrLxZ5lhPKVc8J+OA0GS0Ikb2KLxRzxUzyngmZA0tlZGhqpfLSMezMPKIAA6lMbTjXnTdptDyMvIIHUM/DfKINjTSfpy8JNHv4kHLy8gjJAwvNcvQz+2NTi22LKN5a7ASjzXkIYOzHtkkGCT/4715JcfLlUePEIDW/R98eFC9cs5VYUsymjcs2qiMrrpuUqnUtQzuergywKeOf/iHXQ0UYM3mK+68fmS+w6Z+ZtPrmyMADdWvjb326xNKXRiznBZIozvfWXuSnY2KrN888baZ4/xdb1LT2NE1qw8y52pk957Xpn7zxuFyYYNFGze+s+VCxnQ5Xr1n4VdvuLJC6Ryp2h3rt5/NmEfoDWs3LbrttrGewgWLNq17c2c2iZZa838rh0+dPmFkiZzrBaNq4/E/b9hzpt1SO1a957Xbv3WJoxNnZlzZ0Xk/ghdn2Z8w6kA1ZXJgDArG8fwYrs99LMMURjYopmwRjEGBnl3/yraOdinkARXjpoy7aPAQv5yWocVp08kDuw6cbOrIQyiNuvvu4VKmDDv1ANIE3VTd6mPFtyze0EUsqy9cNqSsbGDY7/GobS0X6s/XNbZ0sQck/c393xpBevIT5q9HmgRDyoM8QjeRR+h5kEdIaRIM7fCi9xq7cvLF4/UHDSosCnl5UPUj/7Hy8ZnhNAmGnXo4NWY1vLv4SL5UknnClJ6IbH941iNTSMEM8NquBettJG5qXrrt0bucWOQ6ISPy8tz3bSW50g/+8F8O00IAix6e9+QXdmsSXf7AKvsZ2hTz6od/4vTU+id3OZDHhO57/KG5A+1NAG8QclpIam7EjOaXOD267PlTDjEY+mc9NRrs0iPTn2UhqbkV8git4flXHGOZi71V/8vJNunhwMEQeuanv3WOkQ+09Q9usvWLtxMs+vkPfpcEBwvd9e01Wu8Ei3723TVObzgc/tEqrTeCRffO+5Pz6bxqnlit2Q4W951ceuSRTc5jBVDzxJ+oXTvShA3AvI55pI9g1H5/jRtYAcAlC6sIPz0A0kdJQEmZXDQ9TM7+18Tp9T/90CWs4NCPlkzkpgeDztZwlNb577m2mUx3/rjG3jGLb0m+uiwFrhV93TMtvQcsuvbFKLhYUq8vVXsNWId+Vgeulujz23sLWE1PfwYulzPPnrahVxJn6yqGXfeCS0yBH6lFT8bdBgvk7z3l66Ee0C6ARcFTlz1Lzg6mxOk7XnQfK9DenHEz6ZkekJ0A3obPsPGFkyBAqZ9/Wvwxi676iIoAFt26VBMerBMLoyBESSzaKzpY2tKDIEg58VJScLAOrBDmzCx9dwfvqUMs0xdhPTl7Vi35k5eoKGABmfOrom7q0cFFviQYB//xJIhThqyY3k09nCDBSC2vFQgrqH8zIfCYdWKVLhJY9I+HxAVLXyPSRwgAtSs1YcG68MeUWGCp79cJC9bufSBY2b+VZ2+MTbI7ydnbJU5PfRARDazoyuu9lvWADhPAB3N6HfJJzt4ucfqJrVQ0sOjGI6Ms6wEdJIDn+hnuOAHClVO7xByztHUJ8cBKbtCEBKthBxUPLLq7QUiwDh0DAcsXn4sIFt3VIiJYkU/5ve8sh4X15OztEqentlARwaLVoFjSA//kSgCfzo5iOTl7u8Tp9ftByHI0VWpJDwDoIAG8kXfHenL2dsd7z54RE6zT58ot6ZGjRrnnZD3eKiZYLUfFG+Dp8YSYYMU/p8KBpZ6gYoJFj6nCgZU6CYKWE9w2eYy0slaTs7dLnB5rEBWs860lFvToJAE8KMihxwwo8aOjPoaDtTfMVuvImxHKQR5BY7gZ4IeIqGA1ni22oAc2TbYyrwNyjERykWDkzniXnSU3M5YonfEu0iIqWK0RK3qY5wzmbL/cxqxIQlSw4tzOE3ADSzD2pkzXUUQ4sCLCgqWL92YlqahgUX5TB2POYDE5e7uThClxwVKt6NFJAnhQ0EayCAsaZzsVJgOqmAyoFMiMTCA+5uFvExYsKJIs6GGaNKmmyUYHJBjEDKwR7coMaC7yCOoRlhBPCljRw/wSspmqxNnrEBQWLJlbvnduKg7yigpWcKh4YA0UFayh5eKBNVJUsC7llnUmiwQj/+Ts2cvI4NRPxLSHRX/vSVnQoxP2DOPMA02ypOZoMFLoL1NYNCPO6iQvy3+OLmzG5JtEg+FRPr6zSUiwxr492pIeOGdgUZk4EOtsxq2wHSDLydnbJU6fOmWDiFhJNw9TLemBuOZKAM9xw6J0TpGIYFXezY/1ih9Y5OYqAbHyf7cSBAQLBv+gTDis5G/cLgkJFlw3V7QPUfrqD3nmuOUJlv+xmbJQWJGv/Hw01/4ipvmWleTs7ROn0+Pf/0gX6b2af1m39OgoATzncJRT/75KFQWropueHM83JytnNsnKFwYtFyPekAx5YC7v5Spv6s2LfnnJgloB1j3eqnnTuZsb7jylJY9e/l/r3d4Wk0bPmT2EP88rf1JXzzWT3nlxn5sjlzx69h2j7PBF2sGAWzZ3xhtvHUq6BJVv/Ozbx8RsCSLiHMlqVOnpdW9XNzs/dillU2+ZMUzmpkfWRbtysuqN29//5HjcSbzk0snXVY0NErArJ6ttRNRS2Y0zajZ+tKPGoT0y79BJV//dJQOidm6M28na7R1VNrP+8LadR+pj9gLmKxs1Zcbk4QEC9sqxmeJcGTbsmvj52r27j5xqidmwEpL8xeWVk8ePKQ8VO7AV5wAfvO/iiTekms8dO3Lg2LmGSFLlgpnk8Q4oG145dsxFwWKFdMiD2evAAgDiHTx4kt4Ya2moP3Wmoe5cUzQSU3Vdt/jVEEmS5EAgUDKkvHzEyIqyYq9CjMHXETUYfZOZPion71QWmZS5aU7eqSzCKtZUTyXbWlpbmhsbm1tao5FIWyKparquabqu65RSSgGAACFEIpIky7Ls8fgCgWDIHyotG1RaXBz2ez1K5zLs0YOz18Gikaaq2taqaWoyCYqqqpqWimpUB0r8EiGSJCWIong83pKgoiiyhxGW25lk3lGvg9X32uNhJ1LyUcR1509/Msh+sPrB6gerNxV2DIAYjnpGbM1OQGBNMmp4OMAUCJomtmb9YE03atgUgxp7vYy01wGTmndqQHMmTu/USOdMnN57ZaQ/wzymwTkTp3c+M+i0g94no3/M6h/g7Sn/DwTGbJ7MhBbGAAAAAElFTkSuQmCC',
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
  };
};

export default authProvider;
